/***
 * @file:
 * @author: caojianping
 * @Date: 2021-05-24 16:42:23
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { DtBrowserModule } from '@ithinkdt/shared/browser';

import { MenuService } from './menu.service';

import { MenuNodesComponent } from './menu-nodes/menu-nodes.component';
import { SingleMenuNodeComponent } from './menu-nodes/single-menu-node/single-menu-node.component';
import { MenuComponent } from './menu.component';

const ANGULAR_MODULES = [CommonModule, FormsModule, ReactiveFormsModule, RouterModule];

const THIRD_MODULES = [TranslateModule];

const ANTD_MODULES = [NzIconModule, NzToolTipModule];

const DT_MODULES = [DtBrowserModule];

const COMPONENTS = [MenuNodesComponent, SingleMenuNodeComponent, MenuComponent];

@NgModule({
  imports: [...ANGULAR_MODULES, ...THIRD_MODULES, ...ANTD_MODULES, ...DT_MODULES],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
  providers: [MenuService],
})
export class DtMenuModule {}
